import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import Badge from 'react-bootstrap/lib/Badge';

import connectToStores from '../../helpers/connectToStores';
import { displayNotifications } from '../../helpers/NotificationCentre';
import { translate as t } from '../../lib/I18n';
import NotificationCentreStore from '../../stores/NotificationCentreStore';

import DropDownItem from '../nav/DropDownItem';


export function NavTrigger ({ closeMenu, notifications }) {
    if (!notifications.size) {
        return null;
    }
    const clickHandler = () => {
        closeMenu();
        displayNotifications();
    };
    return (
        <DropDownItem>
            <button
                className="btn btn-default text-sm"
                data-test-id="nav-account-dropdown-item-notifications"
                onClick={ clickHandler }
            >
                <span>{ t('notifications.accountActions.text') }</span>
                <Badge className="badge_notification text-center" pullRight>{ notifications.size }</Badge>
            </button>
        </DropDownItem>
    );
}

NavTrigger.propTypes = {
    closeMenu: PropTypes.func.isRequired,
    notifications: PropTypes.instanceOf(List)
};

const _getStateFromStores = () => {
    const notifications = NotificationCentreStore.getNotifications();
    return { notifications };
};

export default connectToStores([ NotificationCentreStore ], _getStateFromStores)(NavTrigger);
